import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";

import {
  CUSTOMER_FRONTEND_ENDPOINTS,
  REQUEST_STATUS,
  REQUEST_TYPE,
  SendMagicLinkResponse,
  VerifyMagicLinkResponse,
} from "../../types";
import { flattenResponse } from "../flattenResponse";

interface ISendMagicLink {
  email: string;
  shopifyDomain: string;
}

export const sendMagicLink = async ({ email, shopifyDomain }: ISendMagicLink): Promise<SendMagicLinkResponse> => {
  const reqBody = {
    email,
    orgShopifyDomain: shopifyDomain,
    reqType: REQUEST_TYPE.LOGIN,
  };

  const res = await typedCustomerFrontendApi.postReq(CUSTOMER_FRONTEND_ENDPOINTS.SEND_MAGIC_LINK, {
    reqBody,
  });

  if (res.type === REQUEST_STATUS.SUCCESS) {
    return flattenResponse(res);
  }
  return res;
};

export const verifyMagicLink = async (cid: string): Promise<VerifyMagicLinkResponse> => {
  const res = await typedCustomerFrontendApi.postReq(CUSTOMER_FRONTEND_ENDPOINTS.VERIFY_MAGIC_LINK, {
    reqBody: {
      verificationParams: cid,
    },
  });

  if (res.type === REQUEST_STATUS.SUCCESS) {
    return flattenResponse(res);
  }
  return res;
};
